import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

/**
 * Generic controlled selector component via material-ui
 */
const Selector = ({
  options,
  selected = null,
  onChange,
  showNullOption = false,
  multiple = false,
  disabled = false,
  renderValue,
  displayEmpty,
  className = 'ob-selector',
  label = '',
}) => (
  <FormControl className={className}>
    {label ? <InputLabel>{label}</InputLabel> : null}
    <Select
      multiple={multiple}
      value={options.length && selected ? selected : ''}
      onChange={onChange}
      disabled={disabled || (!!selected && options.length < 2)}
      renderValue={renderValue}
      displayEmpty={displayEmpty}
    >
      {showNullOption ? (
        <MenuItem key="nullval" value={null}>
          ---
        </MenuItem>
      ) : null}
      {options.map(({ key, id, display }) => (
        <MenuItem key={key} value={id} className={`${className}-option`}>
          {display}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default Selector;
